export const RadioSelectedIcon = ({ color = '#2463f9' }) => (
  <svg xmlns='http://www.w3.org/2000/svg' width='20' height='21' viewBox='0 0 20 21' fill='none'>
    <circle cx='10' cy='10.875' r='9.5' stroke={color} />
    <circle cx='10' cy='10.875' r='5' fill={color} />
  </svg>
)
